module.exports = __webpack_public_path__ + "static/media/pic11.64ee9314.jpg";